//Create-Join-ArrowLeftIcon-ArrowRightIcon-MeetingEnterIcon-SettingsIcon-LeaveRoom-SaveChanges-AddFiles-DownloadIcon-Cancel-Confirm-Yes-No
import React, { useState } from 'react';

import { Badge, Button, Icon, IconButton, List, ListItem, ListItemText, makeStyles, Tooltip } from "@material-ui/core";
import { AddSharp, AttachFileSharp, ChevronLeftSharp, ChevronRightSharp, CloseSharp, ExpandLess, ExpandMore, FileCopyOutlined, HistorySharp, Info, InsertDriveFile, LockOpenOutlined, LockOutlined, MeetingRoomSharp, MicOutlined, NoMeetingRoom, SaveAltSharp, SettingsSharp, ShareOutlined, VolumeUpOutlined } from '@material-ui/icons';
import { toast } from 'react-toastify';
import qr from '../media/images/qr-code.svg';

const useStyles = makeStyles((theme)=>({

    createRoom : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        display : 'flex',
        width : '60%',
        justifySelf : 'center',
        height : '7vh',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    label : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1rem !important',
    },
    createMobRoom : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        width : '60%',
        height : '8vh',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    Icon : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        justifySelf: 'flex-start',
        marginRight : '1vw'
    },
    Meeting : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        justifySelf: 'flex-start',
        width : '50px',
        height : '50px',
        '&:hover' : {
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
            borderColor : '#e5e7eb',
            border : '1px solid',
        }
    },
    MeetingMob : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        justifySelf: 'flex-start',
        marginLeft : '30px',
        width : '13vw',
        height : '13vw',
        '&:hover' : {
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
            borderColor : '#e5e7eb',
            border : '1px solid',
        }
    },
    JoinRoom : {
        color : '#e5e7eb',
        border : '2px solid white',
        height : '7vh',
        width : '35%',
        justifySelf: 'center',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    JoinMobRoom : {
        color : '#e5e7eb',
        border : '2px solid white',
        height : '8vh',
        justifySelf: 'center',
        fontFamily: 'primary !important',
        width : '80%',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop : '2vh',
    },
    Arrow : {
        color : '#fe752f',
        backgroundColor : 'black',
        justifySelf: 'flex-start',
        marginRight : '1vw',
        '&:hover' : {
            borderColor: '#fe752f',
            border : '1px solid',
        }
    },
    Settings : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : '#1c1c1c',
            color : '#fe752f',
            border : 'none',
        },
    },
    Clipboard : {
        color : '#fe752f !important',
        backgroundColor : ' #1c1c1c',
        justifySelf: 'flex-start',
        marginRight : '1vw',
        '&:hover' : {
            border : '1px solid #fe752f !important',
        }
    },
    Close: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color : '#fe752f',
        backgroundColor : 'black',
        // justifySelf: 'flex-end',
        '&:hover' : {
            borderColor: '#fe752f',
            border : '1px solid',
        }
    },
    CloseMob: {
        color : '#fe752f',
        backgroundColor : 'black',
        // justifySelf: 'flex-end',
        '&:hover' : {
            borderColor: '#fe752f',
            border : '1px solid',
        }
    },
    Details: {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        minWidth : '10vw',
        minHeight : '5vh',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        margin : '1vw',
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    SaveChanges : {
        color : '#fe752f',
        border : '0',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    AddFiles : {
        backgroundColor : ' #1c1c1c',
        color : '#fe752f',
        border : '0',
        width : 'fit-content',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        boxShadow : 'none',
        '&:hover' : {
            backgroundColor : ' #1c1c1c',
            color : '#fe752f',
        }
    },
    AddMobFiles : {
        backgroundColor : ' #1c1c1c',
        color : '#fe752f',
        border : '0',
        width : 'fit-content',
        height : '7vh',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        boxShadow : 'none',
        '&:hover' : {
            backgroundColor : ' #1c1c1c',
            color : '#fe752f',
        }
    },
    LeaveRoom : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        display : 'flex',
        width: 'fit-content',
        minHeight : '5vh',
        margin : '1vw',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    GenKey : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        display : 'flex',
        minWidth : '10vw',
        minHeight : '5vh',
        marginLeft : '2vh',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    Share : {
        backgroundColor : '#fe752f',
        color : '#e5e7eb',
        border : '0',
        animation: 'none',
        display : 'flex',
        width : '40%',
        minWidth : '10vw',
        minHeight : '5vh',
        margin : '1vw',
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        '&:hover .MuiButton-contained':{
            backgroundColor: '#fe752f'
        },
        '&:hover':{
            backgroundColor : '#fe752f',
            color : '#e5e7eb',
        }
    },
    micButton: {
        borderRadius: '5px',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : '#fe752f',
            border : '1px solid #fe752f',
            borderRadius : '50%',
        },
    },
    RoomStatusIconButton : {
        borderRadius: '5px',
        width : '100%',
        height : '7vh',
        "& .MuiSvgIcon-root" : {
            fontSize : '2.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : '#fe752f',
            border : 'none',
        },
    },
    HistBtn : {
        color : '#fe752f',
        padding : '0 !important',
        background: '#373737',
        height: '7vh',
        borderRadius: '0',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
            paddingLeft: '5px',
        },
        "&:hover" : {
            background: '#343434',
        }
    },
    HistBtnMob : {
        color : '#fe752f',
        padding : '0 !important',
        background: '#373737',
        height: '6vh',
        borderRadius: '0',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
            paddingLeft: '5px',
        },
        "&:hover" : {
            background: '#343434',
        }
    },

    ShareRoomLinkViaAudioButton : {
        color : '#fe752f',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : '#1c1c1c',
            color : '#fe752f',
            border : 'none',
        },
    },
    InsertFilesIcon : {
        borderRadius: 'none',
        width: 'fit-content',
        justifySelf: 'flex-end',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        },
        "& :hover" : {
            backgroundColor : 'black',
            color : '#fe752f',
            border : 'none',
            borderRadius : '50%',
        },
    },
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop : '1vh',
    },
    Content : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    dialog : {
        backgroundColor : 'black',
        color : 'white',
    },
    label : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1rem !important',
    },
    listItem : {
        height : '5vh',
        borderRadius : '5px',
        backgroundColor : '#fe752f !important',
        color : 'white !important',
        '&:hover': {
            backgroundColor : '#fe752f',
            color : 'white',
        },
        '&:focus': {
            backgroundColor : '#fe752f',
            color : 'white',
        }
    },
    text : {
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    mobText : {
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    hover : {
        color : 'white',
        backgroundColor : 'transparent',
        '&:hover' : {
            backgroundColor : 'transparent',
            color : 'white',
            border : 'none',
        }
    },
    notHover : {
        backgroundColor : '#fe752f',
        color : 'white',
    },
    volButton : {
        "& .MuiIconButton-label" : {
            width : '2vw',
            height : '2vw',
        },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        }
    },
    DialogActionStyle : {
        justifyContent : 'center',
    },
    audioBadge : {
        top : '1vh',
        padding : "0 !important",
        right : '0px',
    },
    icon : {
        color : '#fe752f',
        fontSize : '1.5rem !important',
        marginTop : '2vh', 
        "& .MuiSvgIcon-root" : {
            fontSize : '1.25rem !important',
            color : '#e5e7eb',
        },
        "& :hover" : {
            backgroundColor : 'transparent',
            color : '#fe752f',
            border : 'none',
        },
    }
}))

export const CreateRoomBtn = function CreateRoomBtn({ handleClick }){

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.createRoom, label : classes.label }} onClick={()=>{ handleClick() }} variant="contained" color="primary" disableElevation>
            <Icon classes={{ root : classes.Icon }} >
                <AddSharp />
            </Icon>
            Create Portal
        </Button>
    )

}

export const CreateRoomMobBtn = function CreateRoomMobBtn({ handleClick }){

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.createMobRoom, label : classes.label }} onClick={()=>{ handleClick() }} variant="contained" color="primary" startIcon={<Icon  >
            <AddSharp />
        </Icon>} disableElevation>
            Create Portal
        </Button>
    )

}


export const JoinRoomBtn = function JoinRoomBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.JoinRoom, label : classes.label }}  onClick={()=> { handleClick() }} color="primary" >
            JOIN PORTAL
        </Button>
    )

}

export const JoinRoomMobBtn = function JoinRoomMobBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.JoinMobRoom, label : classes.label }}  onClick={()=> { handleClick() }} color="primary" >
            JOIN PORTAL
        </Button>
    )

}

export const ArrowLeftIconBtn = function ArrowLeftIconBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <IconButton classes={{ root : classes.Arrow }} onClick={()=>{ handleClick() }} >
            <ChevronLeftSharp />
        </IconButton>
    )

}

export const ArrowRightIconBtn = function ArrowRightIconBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <IconButton classes={{ root : classes.Arrow }} onClick={()=>{ handleClick() }} >
            <ChevronRightSharp />
        </IconButton>
    )

}

export const MeetingIconBtn = function MeetingIconBtn ({ view ,handleClick }) {

    const classes = useStyles();

    if( view === 'mobile'){
        return (
            <IconButton classes={{ root : classes.MeetingMob }} onClick={()=>{ handleClick() }} >
                <MeetingRoomSharp />
            </IconButton>
        )
    } else if ( view  === "desktop" ) {
        return (
            <IconButton classes={{ root : classes.Meeting }} onClick={()=>{ handleClick() }} >
                <MeetingRoomSharp />
            </IconButton>
        )
    }

    

}

export const SettingsIconBtn = function SettingsIconBtn ({ handleClick }) {

    const classes = useStyles();

    return (
        <IconButton classes={{ root : classes.Settings }} onClick={()=>{ handleClick() }} >
            <SettingsSharp />
        </IconButton>
    )

}

export const ClipboardButton = function ClipboardButton ({ view , handleClick }) {

    const classes = useStyles();

    return(
        <IconButton classes={{ root : classes.Clipboard }} onClick={handleClick} disabled={!view} >
           <AttachFileSharp /> 
        </IconButton>
    )

}

export const SaveChangesBtn = function SaveChangesBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.SaveChanges, label : classes.label }}  onClick={()=> { handleClick() }} color="primary" >
            SAVE CHANGES
        </Button>
    )

}

export const AddFilesBtn = function AddFilesBtn({ view, handleClick, disabled}) {

    const classes = useStyles();

    if(view === 'mobile'){
        return (
            <React.Fragment>
                    <Button classes={{ root : classes.AddMobFiles, label : classes.label }} variant="contained" onClick={()=>{ document.getElementById('addFileInp').click() }} >Add Files</Button>
                    <input multiple type="file" id="addFileInp" style={{display:'none'}} onChange={e=>handleClick(e.target.files)}  name="Add Files" />
            </React.Fragment>
        )
    }else if(view === 'desktop'){
        return (
            <React.Fragment>
                    <Button classes={{ root : classes.AddFiles, label : classes.label }} variant="contained" onClick={()=>{ document.getElementById('addFileInp').click() }} >Add Files</Button>
                    <input multiple type="file" id="addFileInp" style={{display:'none'}} onChange={e=>handleClick(e.target.files)}  name="Add Files" />
            </React.Fragment>
        )
    }

}

export const DownloadIconBtn = function DownloadIconBtn ({ handleClick }) {

    const classes = useStyles();

    return (
        <IconButton classes={{ root : classes.Arrow }} onClick={()=>{ handleClick() }} >
            <SaveAltSharp />
        </IconButton>
    )

}

export const LeaveRoomBtn = function LeaveRoomBtn({ handleClick }){

    const classes = useStyles();

    return (
        <Button id="leaveRoomDesktop" classes={{ root : classes.LeaveRoom, label : classes.label }} onClick={()=>{ handleClick() }} variant="contained" color="primary" disableElevation>
            Leave Portal
        </Button>
    )

}

export const GenKeyBtn = function GenKeyBtn({ handleClick }){

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.GenKey, label : classes.label }} onClick={()=>{ handleClick() }} variant="contained" color="primary" disableElevation>
            Change 
        </Button>
    )

}

export const MicButton = function MicButton({ handleAudioClick }) {

    const classes = useStyles();
    const [display, setDisplay] = useState(false);

    return(
        <Tooltip title="Listen Audio QR Code" >
            <IconButton onClick={handleAudioClick} classes={{ root : classes.micButton }} > 
                <MicOutlined />
            </IconButton>
        </Tooltip>
    )

}

export const HistortyBtn = function HistortyBtn({ handleClick, view }) {

    const classes = useStyles();

    return(
        <Tooltip title="Click to select from previous portals">
            <IconButton onClick={handleClick} classes={{ root : (view == "desktop")?classes.HistBtn: classes.HistBtnMob }}>
                <HistorySharp />
            </IconButton>
        </Tooltip>
    )

}

export const ShareViaAudioIconButton = function ShareViaAudioIconButton({ handleClick, handleBadgeClick, display }) {
    const classes = useStyles();

    // if(!display) {
    //     return (
    //         <Tooltip title="Share room link via audio" >
    //             <IconButton onClick={()=>{ handleClick() }} classes={{ root : classes.ShareRoomLinkViaAudioButton }} >
    //                 <VolumeUpOutlined />
    //             </IconButton> 
    //         </Tooltip>
    //     )
    // } 
    return (
        <>
            <Badge classes={{ badge : classes.audioBadge }} style={{ cursor: 'pointer' }} badgeContent={ 
                <IconButton classes={{ root : classes.icon }}>
                    <Info />
                </IconButton>
             } onClick={()=>{ handleBadgeClick() }} >
                {null}
            </Badge>
            <Tooltip title="Share room link via audio" >
                <IconButton onClick={()=>{ handleClick() }} disabled={!display} classes={{ root : classes.ShareRoomLinkViaAudioButton }} >
                    <VolumeUpOutlined />
                </IconButton> 
            </Tooltip>
        </>
    )

}

export const InsertFileIconButton = function InsertFileIconButton({handleClick}){
    const classes = useStyles();

    return (
        <IconButton onClick={()=>{ document.getElementById('addFileIconInp').click() }} classes={{ root : classes.InsertFilesIcon }} >
            <InsertDriveFile />
            <input multiple type="file" id="addFileIconInp" style={{display:'none'}} onChange={e=>handleClick(e.target.files)}  name="Add Files Icon" />
        </IconButton>
    )
}

export const RoomStatusIconButton = function RoomStatusIconButton({ handleClick, status, handleBadgeClick }) {
    const classes = useStyles();

    if(status) {
        return (
            <>
            <Badge style={{ cursor: 'pointer' }} badgeContent={ 
                <IconButton classes={{ root : classes.icon }} >
                    <Info />
                </IconButton>
             } onClick={()=>{ handleBadgeClick() }} >
                {null}
            </Badge>
            <Tooltip title="Public Room" >
                <Button onClick={()=>{ handleClick(false); }} classes={{ root : classes.RoomStatusIconButton }} >
                    <MeetingRoomSharp />
                </Button> 
            </Tooltip>
            </>
        )    
    }

    return (
        <>
            <Badge style={{ cursor: 'pointer' }} badgeContent={ 
                <IconButton classes={{ root : classes.icon }} >
                    <Info />
                </IconButton>
             } onClick={()=>{ handleBadgeClick() }} >
                {null}
            </Badge>
            <Tooltip title="Private Room" >
            <IconButton onClick={()=>{ handleClick(true); }} classes={{ root : classes.RoomStatusIconButton }} >
                <NoMeetingRoom />
            </IconButton> 
            </Tooltip>
        </>
    )

}

export const ConfirmBtn = function ConfirmBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.SaveChanges, label : classes.label }}  onClick={()=> { handleClick() }} color="primary" >
            Confirm
        </Button>
    )

}

export const CancelBtn = function CancelBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.SaveChanges }}  onClick={()=> { handleClick() }} color="primary" >
            Cancel
        </Button>
    )

}

export const YesBtn = function YesBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.SaveChanges , label : classes.label}}  onClick={()=> { handleClick() }} color="primary" >
            Yes
        </Button>
    )

}

export const NoBtn = function NoBtn({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.SaveChanges , label : classes.label}}  onClick={()=> { handleClick() }} color="primary" >
            No
        </Button>
    )

}

export const CloseBtn = function CloseBtn({ view , handleClick }) {

    const classes = useStyles();

    return (
        <IconButton classes={{ root : view === 'mobile' ? classes.CloseMob : classes.Close }} onClick={()=>{ handleClick() }} >
            <CloseSharp />
        </IconButton>
    )

}

export const RoomDetails = function RoomDetails({ roomName, view }) {


    const classes = useStyles();

    var handleShare = () => {
        if (!navigator.share) {
            handleCopyLink('link')
        } else {
            navigator.share({
            title: 'Teleport : File Sharing Tool',
            text: 'Join my room '+ roomName  + ' on Teleport to receive files',
            url: roomName,
            });
        }
    }

    var handleCopyLink = (e) => {

        let copyText1 = document.getElementById(e);
        copyText1.disabled = false;
        copyText1.select();
        document.execCommand("copy");
        copyText1.disabled = true;
        toast.info("Copied to clipboard!",{
            toastId:"Copied to clipboard!"
        })

    }

    if(view === 'mobile' || window.innerWidth < 750){
        return(
            <Button style={{animation: 'none !important',animationName:'none'}} classes={{ root : classes.Share, label : classes.label }} onClick={()=>{ handleShare() }} variant="contained" startIcon={<ShareOutlined />} >
                SHARE
                <input id="link" disabled={true}  value={ window.origin + "/portal/" + roomName } style={{opacity : 0, width : 1}} />
            </Button>
        )
    }

    return (
        <List style={{ margin :'1vw' }} >
            <ListItem onClick={() => handleCopyLink("link")} classes={{ root : classes.listItem }} button >
                <ListItemText classes={{ primary : view === 'mobile' ? classes.mobText : classes.text }} primary={window.origin.slice(8,) + "/portal/" + roomName} />
                <input id="link" disabled={true}  value={ window.origin + "/portal/" + roomName } style={{opacity : 0, width : 1}} />
                <IconButton  style = { view === 'mobile' ? { float: 'right' ,width : '8vw', height : '8vw', } : { float: 'right' ,width : 'auto', height : '5vh', padding : '0' } } classes={{ root : classes.hover }} >
                    <FileCopyOutlined />
                </IconButton>
            </ListItem> 
        </List>
    )

}

export const QrButton = function QrButton({ handleClick }) {

    const classes = useStyles();

    return(
        <IconButton onClick={handleClick} classes={{ root : classes.ShareRoomLinkViaAudioButton }} >
            <img src={qr} alt="QR_ICON" style={{ width : '20px', height : '20px'}} /> 
        </IconButton>
    )

}

export const ShareBtn = function ShareBtn ({ handleClick }) {

    const classes = useStyles();

    return (
        <Button classes={{ root : classes.Share }} onClick={()=>{ handleClick() }} variant="contained" startIcon={<ShareOutlined />} >
            SHARE
        </Button>
    )

}